"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthCookie = exports.randomString = exports.parseJWT = exports.getAuthCookie = exports.generateHash = exports.b64EncodeUnicode = exports.b64DecodeUnicode = void 0;
var _jssha = _interopRequireDefault(require("jssha"));
var _constants = require("../constants");
const b64DecodeUnicode = str => decodeURIComponent(atob(str).split('').map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`).join(''));
exports.b64DecodeUnicode = b64DecodeUnicode;
const b64EncodeUnicode = str => btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
  return String.fromCharCode(`0x${p1}`);
}));
exports.b64EncodeUnicode = b64EncodeUnicode;
const randomString = (len, charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => {
  let rndStr = '';
  for (let i = 0; i < len; i += 1) {
    const randomPosition = Math.floor(Math.random() * charSet.length);
    rndStr += charSet.substring(randomPosition, randomPosition + 1);
  }
  return rndStr;
};
exports.randomString = randomString;
const generateHash = (clientID, privateKey) => {
  const timestamp = Date.now();
  const rawState = `${timestamp}${clientID}`;
  const SHA = new _jssha.default('SHA-256', 'TEXT');
  SHA.setHMACKey(privateKey, 'TEXT');
  SHA.update(rawState);
  return SHA.getHMAC('HEX');
};
exports.generateHash = generateHash;
const parseJWT = token => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = b64DecodeUnicode(base64);
  return JSON.parse(jsonPayload);
};
exports.parseJWT = parseJWT;
const setCookie = (name, value, options) => {
  const path = options.path ?? '/';
  const expires = (options === null || options === void 0 ? void 0 : options.expires) instanceof Date ? options.expires.toUTCString() : options === null || options === void 0 ? void 0 : options.expires;
  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}`;
  if (expires) {
    updatedCookie += `; expires=${expires}`;
  }
  document.cookie = updatedCookie;
};
const setAuthCookie = (token, expires = null) => {
  setCookie(_constants.APF_MID_ACCESS_TOKEN, token, {
    expires
  });
};
exports.setAuthCookie = setAuthCookie;
const getAuthCookie = () => {
  var _document$cookie$spli;
  const token = (_document$cookie$spli = document.cookie.split('; ').find(row => row.startsWith(`${_constants.APF_MID_ACCESS_TOKEN}=`))) === null || _document$cookie$spli === void 0 ? void 0 : _document$cookie$spli.split('=')[1];
  if (!token) {
    return false;
  }
  return token;
};
exports.getAuthCookie = getAuthCookie;